import React, { useEffect, useState } from "react";
import api from "../../api/axios";

export default function PunchLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true); // 👈 loading state added

  useEffect(() => {
    const loadPunchLogs = async () => {
      try {
        const res = await api.get("/user/punches");
        setLogs(res.data);
      } catch (err) {
        console.error("Failed to load punch logs", err);
      } finally {
        setLoading(false); // 👈 hide loading spinner
      }
    };

    loadPunchLogs();
  }, []);

  // Formatters
  const formatDate = (date) => date.split("T")[0];

  const formatTime = (date) => {
    if (!date) return "-";

    const [timePart] = date.split("T")[1].split(".");
    let [hh, mm] = timePart.split(":");

    hh = parseInt(hh, 10);
    const suffix = hh >= 12 ? "PM" : "AM";
    if (hh > 12) hh -= 12;
    if (hh === 0) hh = 12;

    return `${hh}.${mm}${suffix}`; // 👈 consistent format (9.56AM)
  };

  // Process logs: alternate IN/OUT
  const processedLogs = (() => {
    const asc = [...logs].sort(
      (a, b) => new Date(a.punch_at) - new Date(b.punch_at)
    );

    let lastType = null;
    const result = [];

    asc.forEach((punch) => {
      let type;
      if (lastType === null) type = "IN";
      else if (lastType === "IN") type = "OUT";
      else type = "IN";

      lastType = type;

      result.push({ ...punch, type });
    });

    return result.sort((a, b) => new Date(b.punch_at) - new Date(a.punch_at));
  })();

  // ✅ Loading screen (same style as others)
  if (loading) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center vh-100">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted fw-semibold">Loading punch logs...</p>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Punch Logs</h2>

      <div
        className="shadow-sm p-4 rounded-4 bg-white"
        style={{ border: "1px solid #f1f1f1" }}
      >
        {processedLogs.length === 0 ? (
          <p className="text-center text-muted py-4">No punch logs found.</p>
        ) : (
          <table className="table align-middle">
            <thead className="table-light">
              <tr>
                <th>Date</th>
                <th>Time</th>
                {/* <th>Type</th> */}
              </tr>
            </thead>

            <tbody>
              {processedLogs.map((log, index) => (
                <tr key={index}>
                  <td className="fw-semibold">{formatDate(log.punch_at)}</td>
                  <td>{formatTime(log.punch_at)}</td>
                  {/* <td className="fw-bold text-primary">{log.type}</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
